var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9996 100C22.4297 100 0 77.5703 0 49.9996C0 22.4297 22.4297 0 49.9996 0C77.5695 0 99.9992 22.4297 99.9992 49.9996C99.9992 77.5703 77.5695 100 49.9996 100ZM49.9996 4.93141C25.1494 4.93141 4.93141 25.1494 4.93141 49.9996C4.93141 74.8506 25.1494 95.0686 49.9996 95.0686C74.8498 95.0686 95.0678 74.8506 95.0678 49.9996C95.0678 25.1494 74.8506 4.93141 49.9996 4.93141Z",
    fill: "#FA784F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0502 56.8748C25.8468 56.8748 28.9246 53.797 28.9246 50.0004C28.9246 46.2037 25.8468 43.126 22.0502 43.126C18.2535 43.126 15.1758 46.2037 15.1758 50.0004C15.1758 53.797 18.2535 56.8748 22.0502 56.8748Z",
    fill: "#FA784F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9506 56.8748C81.7472 56.8748 84.825 53.797 84.825 50.0004C84.825 46.2037 81.7472 43.126 77.9506 43.126C74.1539 43.126 71.0762 46.2037 71.0762 50.0004C71.0762 53.797 74.1539 56.8748 77.9506 56.8748Z",
    fill: "#FA784F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 75.0001C33 75.0001 39.4693 69.4104 50.3204 69.4682C61.1714 69.526 67 75 67 75",
    stroke: "#FA784F",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.75d31b9e8255461163361184535921b8.svg";
export { ForwardRef as ReactComponent };